import { FC, useCallback } from "react";
import { BadgedDataInput } from "./BadgedDataInput";
import { AttributeGroupWrapper } from "../../detailedPages/AttributeGroupWrapper";
import { ATTRIBUTE_GROUP_STYLES } from "./BadgesGroupsWithInput";
import { VoidFunc } from "../../../../helpers/functions/types";

type BadgesWithInputProps = {
  actualCustomData: string[];
  currentActiveData: string[];
  handleBadgedData: VoidFunc<string[]>;
  inputPlaceholder: string;
};
export const BadgesWithInput: FC<BadgesWithInputProps> = ({
  actualCustomData,
  currentActiveData,
  handleBadgedData,
  inputPlaceholder,
}) => {
  const submitInputValue = useCallback(
    (inputManualValue: string) => {
      if (!currentActiveData.includes(inputManualValue))
        handleBadgedData([...(currentActiveData ?? []), inputManualValue]);
    },
    [currentActiveData, handleBadgedData],
  );

  return (
    <div className={ATTRIBUTE_GROUP_STYLES}>
      <BadgedDataInput
        submitValue={submitInputValue}
        placeholder={inputPlaceholder}
      />
      {!!actualCustomData.length && (
        <AttributeGroupWrapper
          groupAttributesList={actualCustomData}
          initAttributesGroup={currentActiveData}
          handleAttributesGroup={handleBadgedData}
        />
      )}
    </div>
  );
};
